// src/Components/Spinner.js

import React from 'react';
import Lottie from 'lottie-react';
import starsAnimation from '../assets/lottie/stars.json'; // если в src
// Или используйте fetch из public: <Lottie animationData={require('/lottie/stars.json')} />

const Spinner = () => {
  return (
    <div className='fixed left-0 right-0 top-0 bottom-0 flex w-full items-center justify-center z-[60]'>
      <div className="w-[300px]">
        <Lottie
          animationData={starsAnimation}
          loop={true}
          autoplay={true}
        />
      </div>
    </div>
  );
};

export default Spinner;
